import { blogs } from "../pages/StaticPages/Components/BlogLogic/BlogLogic";
import axiosInstance from "./axiosConfig";

// Blog List API
export const getBlogs = async () => {
  try {
    const response = await axiosInstance.get("/blogs");
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return {
      success: false,
      data: [],
    };
  }
};

// Blog Detail API
export const getBlogDetails = async (id) => {
  try {
    // Future API
    const response = await axiosInstance.get(`/blogs/${id}`);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error("Error fetching blog details:", error);
    return {
      success: false,
      data: null,
    };
  }
};

// Recent Blogs API
export const getRecentBlogs = async (currentBlogId) => {
  try {
    const response = await axiosInstance.get("/blogs");
    const allBlogs = response.data || [];
    
    const filteredBlogs = allBlogs.filter(
      (item) => String(item.id) !== String(currentBlogId)
    );

    return {
      success: true,
      data: filteredBlogs.slice(0, 5),
    };
  } catch (error) {
    console.error("Error fetching recent blogs:", error);

    return {
      success: false,
      data: [],
    };
  }
};